import { render, staticRenderFns } from "./PaletteChip.vue?vue&type=template&id=eafb1158&scoped=true&"
import script from "./PaletteChip.vue?vue&type=script&lang=js&"
export * from "./PaletteChip.vue?vue&type=script&lang=js&"
import style0 from "./PaletteChip.vue?vue&type=style&index=0&id=eafb1158&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eafb1158",
  null
  
)

export default component.exports